<template>
	<FormGroup :label="f.name || label" :alias="f.alias || alias" 
		v-slot:default="props" :scope="scope" 
		v-if="(f.access || access) > 0">
		<b-textarea rows="4" v-model="entity[props.alias]" 
			:state="props.state" :data-vv-scope="props.scope" 
			:disabled="(f.access || access) < 30"
			v-validate="validate ? 'required' : null" 
			:name="props.alias" :data-vv-as="f.name || label" 
			autocomplete="off"></b-textarea>
	</FormGroup>
</template>

<script>
export default {
	data: () => ({
		f: {}
	}),
	inject: ['$validator'],
	components: {},
	computed: {},
	watch: {},
	props: {
		item: Object,
		entity: Object,
		label: String,
		scope: String,
		alias: String,
		validate: Boolean,
		access: {
			type: Number,
			default: 60
		}
	},
	methods: {},
	created() {
		if (this.item) {
			this.f = this.item;
		}
	},
	mounted() {}
};
</script>